import { devtools } from 'zustand/middleware';
import type { StateCreator, StoreMutatorIdentifier } from 'zustand';

// Conditionally enable devtools - can be disabled via env var for faster HMR
const ENABLE_DEVTOOLS = import.meta.env.VITE_ENABLE_DEVTOOLS !== 'false';

export function conditionalDevtools<
  T,
  Mps extends [StoreMutatorIdentifier, unknown][] = [],
  Mcs extends [StoreMutatorIdentifier, unknown][] = []
>(
  fn: StateCreator<T, Mps, Mcs>,
  options?: { name?: string }
): StateCreator<T, Mps, Mcs> {
  if (ENABLE_DEVTOOLS) {
    // @ts-expect-error - Complex Zustand middleware type inference issue
    return devtools(fn, options);
  }
  return fn;
}
